import { Module } from 'vuex-smart-module';
import ReportsRepair from '@/modules/reports/store/modules/repairs';
import ReportsSales from '@/modules/reports/store/modules/sales';
import ReportService from '@/modules/reports/store/modules/service';
import ReportsMutuals from '@/modules/reports/store/modules/mutuals';
import ReportsActions from './actions';
import ReportsGetters from './getters';
import ReportsMutations from './mutations';
import ReportsState from './state';

export default new Module({
  state: ReportsState,
  mutations: ReportsMutations,
  actions: ReportsActions,
  getters: ReportsGetters,
  modules: {
    repairs: ReportsRepair,
    sales: ReportsSales,
    service: ReportService,
    mutuals: ReportsMutuals,
  },
});
